import type { RouteObject } from "react-router-dom";
import { preloadable as lazy } from "@/utils/lazyWithRetry";
import AuthLayout from "../../pages/(auth)/Layout";
import {
  QRUploadPage,
  CreatingCompany,
  CreateCompany,
  ESignaturePage,
} from "@/utils/lazyLoadComponents";
import {
  RequireAuthMiddleware,
  RequireInactiveSubscriptionMiddleware,
} from "@/middleware";
import { STANDALONE_PATH_SEGMENTS } from "./standalone-paths";

const CertificateView = lazy(
  () => import("@/pages/(certificate)/CertificateView"),
);
const SubscriptionBuyTokens = lazy(() =>
  import("@/pages/(home)/(company)/subscription/buy-tokens").then((m) => ({
    default: m.SubscriptionBuyTokens,
  })),
);
const SubscriptionPlan = lazy(() =>
  import("@/pages/(home)/(company)/subscription/upgrade-plan").then((m) => ({
    default: m.SubscriptionPlan,
  })),
);
const StripePaymentPage = lazy(() =>
  import("@/components/stripe-card-payment").then((m) => ({
    default: m.StripePaymentPage,
  })),
);
const SubscriptionExpired = lazy(() =>
  import("@/components/subscription/subscription-expired").then((m) => ({
    default: m.SubscriptionExpired,
  })),
);
const NfcLandingPage = lazy(() =>
  import("@/pages/(public)/NfcLandingPage").then((m) => ({
    default: m.NfcLandingPage,
  })),
);
const EventRsvpPage = lazy(() =>
  import("@/pages/(public)/EventRsvpPage").then((m) => ({
    default: m.EventRsvpPage,
  })),
);
const DigitalIdPage = lazy(() => import("@/pages/(public)/DigitalIdPage"));
// No auth middleware on purpose — this screen exists precisely because the API
// can't be reached to validate the (still valid) session.
const ConnectionLost = lazy(() => import("@/pages/(public)/ConnectionLost"));

export const standaloneRoutes: RouteObject[] = [
  {
    path: STANDALONE_PATH_SEGMENTS.QR_UPLOAD,
    Component: QRUploadPage,
  },
  {
    path: "",
    element: (
      <RequireAuthMiddleware>
        <AuthLayout />
      </RequireAuthMiddleware>
    ),
    children: [
      {
        path: STANDALONE_PATH_SEGMENTS.CREATE_COMPANY,
        Component: CreateCompany,
      },
    ],
  },
  {
    path: STANDALONE_PATH_SEGMENTS.CREATING_COMPANY,
    Component: CreatingCompany,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_TOKENS,
    Component: SubscriptionBuyTokens,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_PLAN,
    element: (
      <RequireInactiveSubscriptionMiddleware>
        <SubscriptionPlan />
      </RequireInactiveSubscriptionMiddleware>
    ),
  },
  {
    path: STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_EXPIRED,
    Component: SubscriptionExpired,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.STRIPE_PAYMENT,
    Component: StripePaymentPage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.E_SIGN,
    Component: ESignaturePage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.CERTIFICATE,
    element: (
      <RequireAuthMiddleware>
        <CertificateView />
      </RequireAuthMiddleware>
    ),
  },
  {
    path: STANDALONE_PATH_SEGMENTS.CERTIFICATE_COMBINED,
    element: (
      <RequireAuthMiddleware>
        <CertificateView />
      </RequireAuthMiddleware>
    ),
  },
  {
    path: STANDALONE_PATH_SEGMENTS.NFC_LANDING,
    Component: NfcLandingPage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.NFC_ACTION,
    Component: NfcLandingPage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.DIGITAL_ID_PUBLIC,
    Component: DigitalIdPage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.EVENT_RSVP,
    Component: EventRsvpPage,
  },
  {
    path: STANDALONE_PATH_SEGMENTS.CONNECTION_LOST,
    Component: ConnectionLost,
  },
];
